import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { BtnLinkNameProps } from '../types/interfaces'

interface BtnLinkNameOptions {
  props: BtnLinkNameProps
}

interface BtnLinkNameReturn {
  refIsTooltipShown: ComputedRef<boolean>
}

export const useBtnLinkName = ({ props }: BtnLinkNameOptions): BtnLinkNameReturn => {
  const refIsTooltipShown = computed<boolean>(() => {
    return !!props.tooltipText && !props.disabled && props.target === '_blank'
  })

  return {
    refIsTooltipShown,
  }
}
